import React from "react";
import "../../css/components/FeatureCards.css";
import { ReactComponent as HighlyExperiencedIcon } from "../../assets/icons/Home1.svg";
import { ReactComponent as PersonalisedServiceIcons } from "../../assets/icons/Home2.svg";
import { ReactComponent as JargonFreeIcon } from "../../assets/icons/Home3.svg";

export const defaultFeatures = [
  {
    icon: HighlyExperiencedIcon,
    title: "Highly Experienced",
    description:
      "Our specialised team boast a total of over 50 years of combined professional experience in the financial services industry.",
  },
  {
    icon: PersonalisedServiceIcons,
    title: "Personalised Service",
    description:
      "We pride ourselves on using our experience to give relevant and straight forward, easy to understand advice that best suits you. ",
  },
  {
    icon: JargonFreeIcon,
    title: "Jargon Free",
    description:
      "We believe in cutting through the jargon to give straight forward and honest advice which gives clients their best possible outcome.",
  },
];

const FeatureCards = ({ features }) => {
  const featuresToShow = features || defaultFeatures;
  return (
    <section className="feature-cards-section">
      <div className="feature-cards-container">
        {featuresToShow.map((feature) => (
          <div
            className="feature-card"
            key={feature.title}
            onClick={feature.onClick}
            style={{ cursor: feature.onClick ? "pointer" : "default" }}
          >
            <feature.icon className="feature-card-icon" />
            <h4 className="subtitle-semibold grey">{feature.title}</h4>
            <div className="content grey">{feature.description}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureCards;
